import type {Mode} from "home/gating";
import {transferIdFromPath} from "core/transfer/transferPath";

export interface ReplyTarget {
	transferId: string;
	senderEmail: string | null;
}

/** A resolved transfer may retain its draft, but never mounts a composer on another route. */
export function replyTargetForPath(pathname: string, target: ReplyTarget | null): ReplyTarget | null {
	return target !== null && transferIdFromPath(pathname) === target.transferId ? target : null;
}

export function replyRecipients(email: string | null): string[] {
	return email ? [email] : [];
}

export function replyMode(picked: Mode, active: boolean): Mode {
	return active ? "upload" : picked;
}

/** Only entering a different active reply seeds recipients; reopening preserves the edited draft. */
export function replyRecipientSeed(target: ReplyTarget | null, active: boolean, seededId: string | null): string[] | null {
	return active && target !== null && target.transferId !== seededId ? replyRecipients(target.senderEmail) : null;
}

